<template>
    <div>
        <vggrid  :random="Math.floor(Math.random() * 999999)" ref="xGrid" :list="pqcitemCrossList" tableheight="600" flexname="" :cols="cols"
                :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'
        >
            <template slot="btn">
                <div class="export-btn-container">
                    <el-button type="primary" size="small" @click="exportPDF" :loading="btnLoading" icon="el-icon-download">导出初审表PDF</el-button>
                </div>
            </template>
        </vggrid>
        <div class="split-line"></div>
        <div class="expqc-container">
        <vggrid :list="pqcesList" :random="Math.floor(Math.random() * 999999)" flexname="" :cols="pqcesCols"
                :showfooter="false" :showPage="false" :resizable="true"
        >
            <template slot="btn">
                <div class="expqc-topbtn">
                    <div class="expqc-topbtn-title">评审人[{{pexpert.pexpertname}}]的预审结论</div>
                </div>
            </template>
        </vggrid>
        </div>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: 'pqcesFormCheckComByEx',
    mixins: [common],
    components: {vggrid},
    props: {
      pexpert: {},
      projectid: {},
      pexpertid: {},
      activeName: {}
    },
    data () {
      return {
        project: {},
        list: [],
        selectList: [],
        pqcitemcheckList: [],
        psuComList: [],
        pqcitemCrossList: [],
        pqcesList: [],
        btnLoading: false,
        model: {},
        isEdit: true,
        mergeRow:['pqcitemchecktypedesc'],
        pqcesCols: [
          {field: 'comfullname', fieldtype: 'C', title: '投标人', calculExpr: '', addNewRowFlg: false, width: 280},
          {field: 'pqcesresultdesc', fieldtype: 'C', title: '检查结果', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pqcescdesc', fieldtype: 'C', title: '检查意见', calculExpr: '', editRender: { name: 'input'}}
        ],
        cols: []
      }
    },
    async created () {
      await this.getModel()
      this.getCols()
      await this.getPqcitemCrossList()
    },
    watch: {
      async pexpertid () {
        this.getCols()
        await this.getPqcitemCrossList()
      }
      // activeName () {
      //   console.log(this.activeName)
      //   if(this.activeName === 'aysdb') {
      //     this.getCols()
      //     this.getPqcitemCrossList()
      //   }
      // }
    },
    methods: {
      // 交叉表的数据
      async getPqcitemCrossList () {
        this.pqcitemCrossList = []
        this.loading = true
        let project = {}
        project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          method: 'get',
          url: '/expert/getPqcitemCrossByProjectId',
          params: {
            projectid: this.projectid,
            pexpertid: this.pexpertid,
            project:project
          }
        })
        this.pqcitemCrossList = res.pqcitemList
        this.pqcitemcheckList = res.pqcitemcheckList
        this.psuComList = res.psuList
        await this.setCrossCols(res)
        await this.setPqcesList()
        this.loading = false
      },
      // 我的预审结论数据
      async setPqcesList() {
        await this.getPqcesList()
      },
      // 评审人对供应商做检查的过程中，把结果值返回到汇总表
      getPsuPqcesResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.selectList.filter(v => +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过'
          return '1'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过'
              return '2'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossCheckResultDesc (item) {
        // 供应商通过的检查项数
        let pass = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid && +v.pqcitemcheckcomid === +item.psucomid && +v.pqcitemcheckresult === 1)
        // 供应商不通过的检查项数
        let faile = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid &&  +v.pqcitemcheckresult === 2)
        // 供应商的所有检查项
        let selectComList = this.pqcitemcheckList.filter(v => +v.pqcitemcheckpqcitemid === +item.pqcitemid &&  +v.pqcitemcheckcomid === +item.psucomid)
        if (pass.length === selectComList.length && !faile.length) {
          // '通过 1'
          return '通过'
        } else {
          if ((faile.length + pass.length) === selectComList.length) {
            if (faile.length) {
              // '不通过 2'
              return '不通过'
            } else {
              return ''
            }
          } else {
            return  ''
          }
        }
      },
      // 设置交叉表的表头
      async setCrossCols (res) {
        if (res.psuList.length) {
          for(let i=0;i<res.psuList.length;i++) {
            let item = res.psuList[i]
            this.cols.push({
              title:item.comfullname,
              children: [
                {
                  // title: item.appendfilename,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      return this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})
                    },
                    header: ({ column }) => {
                      return [
                        <span onClick={this.fileClick.bind(this,column,item)} style="color: #409EFF;padding-left:10px">{item.appendfilename}</span>
                    ]
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      getCols () {
        this.cols = [
          {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '初审分类', calculExpr: '', addNewRowFlg: false, width: 100},
          {
            field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容', calculExpr: '', addNewRowFlg: false
          }
          // {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '采购文件要求', calculExpr: '', addNewRowFlg: false}
        ]
      },
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
      },
      // 结果汇总表的数据
      async getPqcesList () {
        this.pqcesList = await request({
          url: 'expert/getPqcesByProjectId',
          method: "get",
          params: {
            pexpertid: this.pexpertid,
            projectid: this.projectid
          }
        })
        this.pqcesList = this.pqcesList.map(v => {
          if (+v.pqcesresult === 1) {
            v.checked_1 = true
          }
          if (+v.pqcesresult === 2) {
            v.checked_2 = true
          }
          return v
        })
      },
      exportPDF() {
        this.btnLoading = true
        if (typeof html2canvas === 'undefined' || typeof jsPDF === 'undefined') {
          const script1 = document.createElement('script')
          script1.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'
          script1.onload = () => {
            const script2 = document.createElement('script')
            script2.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
            script2.onload = () => {
              this.generatePDF()
            }
            document.head.appendChild(script2)
          }
          document.head.appendChild(script1)
        } else {
          this.generatePDF()
        }
      },
      generatePDF() {
        const exportContainer = document.createElement('div')
        exportContainer.style.width = '100%'
        exportContainer.style.padding = '20px'
        exportContainer.style.backgroundColor = '#fff'

        const title = document.createElement('h2')
        title.style.textAlign = 'center'
        title.style.marginBottom = '15px'
        title.textContent = '项目初审表'
        exportContainer.appendChild(title)

        const projectInfo = document.createElement('div')
        projectInfo.style.display = 'flex'
        projectInfo.style.justifyContent = 'space-between'
        projectInfo.style.marginBottom = '20px'

        const projectName = document.createElement('span')
        projectName.textContent = `项目名称：${this.project.projectname || ''}`
        projectInfo.appendChild(projectName)

        const projectCode = document.createElement('span')
        projectCode.textContent = `项目编号：${this.project.projectcode || ''}`
        projectInfo.appendChild(projectCode)

        exportContainer.appendChild(projectInfo)

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'

        const thead = document.createElement('thead')
        const headerRow = document.createElement('tr')

        const serialHeader = document.createElement('th')
        serialHeader.style.border = '1px solid #000'
        serialHeader.style.padding = '8px'
        serialHeader.style.textAlign = 'center'
        serialHeader.textContent = '序号'
        headerRow.appendChild(serialHeader)

        const contentHeader = document.createElement('th')
        contentHeader.style.border = '1px solid #000'
        contentHeader.style.padding = '8px'
        contentHeader.style.textAlign = 'center'
        contentHeader.textContent = '评审内容'
        headerRow.appendChild(contentHeader)

        this.psuComList.forEach(item => {
          const supplierHeader = document.createElement('th')
          supplierHeader.style.border = '1px solid #000'
          supplierHeader.style.padding = '8px'
          supplierHeader.style.textAlign = 'center'
          supplierHeader.textContent = item.comfullname
          headerRow.appendChild(supplierHeader)
        })

        thead.appendChild(headerRow)
        table.appendChild(thead)

        const tbody = document.createElement('tbody')
        this.pqcitemCrossList.forEach((row, index) => {
          const dataRow = document.createElement('tr')

          const serialCell = document.createElement('td')
          serialCell.style.border = '1px solid #000'
          serialCell.style.padding = '8px'
          serialCell.style.textAlign = 'center'
          serialCell.textContent = index + 1
          dataRow.appendChild(serialCell)

          const contentCell = document.createElement('td')
          contentCell.style.border = '1px solid #000'
          contentCell.style.padding = '8px'
          contentCell.textContent = row.pqcitemcheckcontent
          dataRow.appendChild(contentCell)

          this.psuComList.forEach(item => {
            const supplierCell = document.createElement('td')
            supplierCell.style.border = '1px solid #000'
            supplierCell.style.padding = '8px'
            supplierCell.style.textAlign = 'center'
            supplierCell.textContent = this.getCrossCheckResultDesc({pqcitemid: row.pqcitemid, psucomid: item.comid})
            dataRow.appendChild(supplierCell)
          })

          tbody.appendChild(dataRow)
        })

        table.appendChild(tbody)
        exportContainer.appendChild(table)

        const judgeInfo = document.createElement('div')
        judgeInfo.style.textAlign = 'right'
        judgeInfo.style.marginTop = '20px'
        judgeInfo.textContent = `评委：${this.pexpert.pexpertname || this.pexpert.pexpertlogincode || ''}`
        exportContainer.appendChild(judgeInfo)

        document.body.appendChild(exportContainer)

        const { jsPDF } = window.jspdf
        const pdf = new jsPDF('l', 'mm', 'a4')

        html2canvas(exportContainer, {
          scale: 2,
          useCORS: true,
          allowTaint: true
        }).then(canvas => {
          const imgData = canvas.toDataURL('image/png')
          const imgWidth = 297
          const imgHeight = canvas.height * imgWidth / canvas.width

          pdf.addImage(imgData, 'PNG', 10, 10, imgWidth - 20, imgHeight)
          pdf.save(`初审表_${this.project.projectname || '项目'}_${this.pexpert.pexpertname || this.pexpert.pexpertlogincode || '专家'}.pdf`)

          document.body.removeChild(exportContainer)
          this.btnLoading = false
        }).catch(err => {
          console.error('生成PDF失败', err)
          if (exportContainer.parentNode) {
            document.body.removeChild(exportContainer)
          }
          this.btnLoading = false
          this.$message.error('生成PDF失败')
        })
      }
    }
  }
</script>
<style lang="scss">
    .expqc-container {
        margin-top: 20px;
            .expqc-topbtn {
                display: flex;
                align-items: center;
                .expqc-topbtn-title {
                    padding-left: 10px;
                    text-align: center;
                }
                .expqc-topbtn-btn {
                    padding-left: 20px;
                }
            }
    }
    .expqc-footbtn {
        text-align: right;
        padding-top: 10px;
    }
    .export-btn-container {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }
</style>
